import {
  DXG,
  DataGridProps,
  useDataGrid,
  IColumnProps,
} from '@lmt/unicorn-shared/app/common/devexpress/Grid/dx-grid';
import { Paper } from '@mui/material';
import React, { FC, useEffect } from 'react';
import styles from '@lmt/unicorn-shared/app/components/common/dataGrid/DataGrid.module.scss';
import { ScrollTableOnScreenToTop } from '@lmt/unicorn-shared/app/helpers/devextreme-helper';
import loader from '@lmt/unicorn-shared/app/animations/loader.gif';

export const DxgLoadPanel = {
  enabled: true,
  showPane: false,
  indicatorOptions: {
    src: loader,
  },
  text: '',
};

export type Props = {
  enableScrollTop?: boolean;
  columns?: IColumnProps[];
};

export const DataGrid: FC<Props & DataGridProps> = (props) => {
  const { enableScrollTop, columns, onOptionChanged, ...rest } = props;

  useDataGrid();

  useEffect(() => {
    if (enableScrollTop) {
      ScrollTableOnScreenToTop('dx-scrollable');
    }
  }, [props.dataSource, enableScrollTop]);

  return (
    <Paper style={{ height: '100%', width: '100%' }}>
      <div className={styles.dataGridContainer}>
        <DXG.DataGrid
          loadPanel={DxgLoadPanel}
          width={'100%'}
          height={'100%'}
          rowAlternationEnabled={false}
          remoteOperations={false}
          showRowLines={true}
          showColumnLines={false}
          paging={{ enabled: false }}
          sorting={{
            showSortIndexes: true,
          }}
          onOptionChanged={(e) => {
            if (enableScrollTop && e.fullName.includes('sortOrder')) {
              ScrollTableOnScreenToTop('dx-scrollable');
            }

            if (onOptionChanged) {
              onOptionChanged(e);
            }
          }}
          {...rest}
        >
          {columns && columns.map((column) => <DXG.Column {...column} />)}
        </DXG.DataGrid>
      </div>
    </Paper>
  );
};
